import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { SftpServer } from './models/sftp-server.model';

@Injectable({
  providedIn: 'root',
})
export class SftpServersService {
  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private alcmeonContext: AlcmeonContextService
  ) {}

  getSftpServersList(): Observable<SftpServer[]> {
    return this.http
      .get<SftpServer[]>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/sftp-servers`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
